import React from 'react';

import {get} from 'lodash-es';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import WelcomeBackModal from 'components/WelcomeBackModal/WelcomeBackModal';
import {
  initializeWelcomeBack,
  createEventRecord,
  setWelcomeBackUiIsVisible,
} from 'modulesV2/actions';
import {WELCOME_BACK_EVENT_NAME} from 'modulesV2/constants/onboardingConstants';
import {
  getModalId,
  getRosterInfo,
  isRosterInfoLoading,
  isDistrictConfigurationLoading,
  getDistrictConfiguration,
} from 'modulesV2/selectors';
import {
  getEventRecordsByName,
  getIsLoading as areEventRecordsLoading,
} from 'modulesV2/selectors/eventRecordSelectors';
import {onboardingUtils} from 'modulesV2/utils';
import {
  getUserProperties,
  getIsUserLoading,
} from 'static/three-oh/src/modules/selectors/userSelectors';
import {
  clearModal,
  setModalId,
} from 'static/three-oh/src/modulesV2/actions/uiActions';
import {eventStream, getEventNameForEventStream} from 'static/three-oh/utils/sessionActivity';

const WELCOME_BACK_MODAL_ID = 'welcomeBackModal';

class WelcomeBackModalContainer extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object,
    isOpen: PropTypes.bool,
  };

  componentDidMount() {
    this.props.actions.initializeWelcomeBack(this.props.user);
  }

  componentDidUpdate(prevProps) {
    const {isOpen, actions} = this.props;
    if (prevProps.isOpen !== isOpen) {
      // In order to prevent rendering multiple modals at the same time,
      // update redux UI store to indicate whether welcome back modal is visible or not.
      if (isOpen) {
        actions.setModalId(WELCOME_BACK_MODAL_ID, {isOpen: true});
      }
    }
  }

  render() {
    const actions = {
      syncClasses: () => {
        this.props.actions.createEventRecord(WELCOME_BACK_EVENT_NAME, {event_name: WELCOME_BACK_EVENT_NAME});
        this.props.actions.clearModal();

        const newEventProps = {
          event_name: getEventNameForEventStream(
            'Classroom',
            null,
            'Update'
          ),
          user_id: this.props.user.id,
          dimension_properties: {
            description: 'Teacher clicked sync classes button in welcome back modal',
            legacy_event_name: 'teacher-engaged-welcome-back-action',
          }
        };
        eventStream(newEventProps, {userId: this.props.user.id, name: 'teacher-engaged-welcome-back-action', type: 'click'});
        // Small timeout to make sure that request made it through.
        setTimeout(() => window.location.href = '/settings/#/classrooms/', 100);
      },
      skipSync: () => {
        this.props.actions.clearModal();
        const newEventProps = {
          event_name: getEventNameForEventStream(
            'Classroom',
            'Cancel',
            'Navigate'
          ),
          user_id: this.props.user.id,
          dimension_properties: {
            description: 'Teacher welcome back modal dismissed',
            legacy_event_name: 'teacher-dismissed-welcome-back-action',
          }
        };
        eventStream(newEventProps, {userId: this.props.user.id, name: 'teacher-dismissed-welcome-back-action', type: 'click'});
        this.props.actions.createEventRecord(WELCOME_BACK_EVENT_NAME, {event_name: WELCOME_BACK_EVENT_NAME});
      },
    };
    return (
      <WelcomeBackModal
        {...this.props}
        actions={actions}
      />
    );
  }
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      initializeWelcomeBack,
      createEventRecord,
      setWelcomeBackUiIsVisible,
      clearModal,
      setModalId,
    }, dispatch
    )
  };
}

function mapStateToProps(state) {
  const isAllDataLoaded = !(
    getIsUserLoading(state) ||
    isRosterInfoLoading(state) ||
    areEventRecordsLoading(state, WELCOME_BACK_EVENT_NAME) ||
    isDistrictConfigurationLoading(state) ||
    get(state, 'teacherSubjects.isLoading')
  );
  const districtConfiguration = getDistrictConfiguration(state);
  const inBulkDistrict = get(districtConfiguration, 'data[0].roster_type', '') === 'bulk';
  const otherModalOpen = Boolean(getModalId(state)) && getModalId(state) !== WELCOME_BACK_MODAL_ID;
  const isTeacher = getUserProperties(state).isTeacher;
  const isOpen = (
    !inBulkDistrict &&
    !otherModalOpen &&
    isAllDataLoaded &&
    isTeacher &&
    onboardingUtils.shouldWelcomeBackTeacher(
      state.user,
      getEventRecordsByName(state, WELCOME_BACK_EVENT_NAME),
      getRosterInfo(state),
    )
  );
  return {
    user: state.user,
    authProvider: get(state, 'user.auth_type'),
    isOpen,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBackModalContainer);
